import { Stack, Typography } from '@mui/material'
import { observer, useLocalObservable } from 'mobx-react-lite'
import { useEffect } from 'react'
import StoreAchievement from '../StoreAchievement'
import { autorun } from 'mobx'
import { Translate } from '@mui/icons-material'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'

const PointDetail = observer(() => {
    const translate = useTranslate()

    const localObserver = useLocalObservable(() => ({
        pointDetail: {
            pv: 0,
            tv: 0,
            compressed_tv: 0,
            active_legs: 0,
            cpv: 0
        },
        pointRequired: {
            pv: 0,
            tv: 0,
            compressed_tv: 0,
            active_legs: 0,
            cpv: 0
        }
    }))

    useEffect(() => {
        const disposer = autorun(() => {
            const achievements = StoreAchievement.getAchievements()[StoreAchievement.getSelectedPeriod()]

            if (achievements) {
                achievements.value?.forEach(item => {
                    if (item.achievement.rankShort === StoreAchievement.getSelectedRank()) {
                        const pv = item.metrics.find(metric => metric.name === 'pv')
                        const tv = item.metrics.find(metric => metric.name === 'tv')
                        const tv_compressed = item.metrics.find(metric => metric.name === 'compressed_tv')
                        const active_legs = item.metrics.find(metric => metric.name === 'active_legs')
                        const cpv = item.metrics.find(metric => metric.name === 'cpv')

                        localObserver.pointDetail.pv = pv ? pv.value : 0
                        localObserver.pointDetail.tv = tv ? tv.value : 0
                        localObserver.pointDetail.compressed_tv = tv_compressed ? tv_compressed.value : 0
                        localObserver.pointDetail.active_legs = active_legs ? active_legs.value : 0
                        localObserver.pointDetail.cpv = cpv ? cpv.value : 0

                        localObserver.pointRequired.pv = pv ? pv.requiredValue : 0
                        localObserver.pointRequired.tv = tv ? tv.requiredValue : 0
                        localObserver.pointRequired.compressed_tv = tv_compressed ? tv_compressed.requiredValue : 0
                    }
                })
            }
        })

        return () => {
            disposer()
        }
    }, [])

    return (
        <Stack gap={'8px'}>
            <PointDetailItem title="PV" value={localObserver.pointDetail.pv} requiredValue={localObserver.pointRequired.pv} />
            <PointDetailItem title="TV" value={localObserver.pointDetail.tv} requiredValue={localObserver.pointRequired.tv} />
            <PointDetailItem
                title={'TV'}
                subtitle={'compressed'}
                value={localObserver.pointDetail.compressed_tv}
                requiredValue={localObserver.pointRequired.compressed_tv}
            />
            <PointDetailItem title={translate('active_legs')} value={localObserver.pointDetail.active_legs} />
            <PointDetailItem title="CPV" value={localObserver.pointDetail.cpv} />
        </Stack>
    )
})

const PointDetailItem = ({ title, subtitle, value, requiredValue }) => (
    <Stack direction={'row'} gap={'12px'} justifyContent={'space-between'}>
        <Stack direction={'row'}>
            <Typography variant="h6" fontFamily={'Inter'} fontSize={'14px'} fontWeight={400} color="rgba(56, 66, 80, 1)">
                {title}
            </Typography>
            {subtitle && (
                <>
                    &nbsp;
                <Typography variant="h6" fontFamily={'Inter'} fontSize={'14px'} fontWeight={400} color="rgba(254, 93, 124, 1)">
                        {subtitle}
                    </Typography>
                </>
            )}
        </Stack>
        <Stack alignItems={'center'} justifyContent={'center'} direction={'row'}>
            <Typography variant="h6" fontFamily={'Inter'} fontSize={'14px'} fontWeight={400} color="#000000">
                {value.toLocaleString()}
            </Typography>
            {requiredValue && (
                <>
                    &nbsp;
                    <Typography variant="h6" fontFamily={'Inter'} fontSize={'14px'} fontWeight={400} color="#9EA9B9">
                        / {requiredValue.toLocaleString()}
                    </Typography>
                </>
            )}
        </Stack>
    </Stack>
)

export default PointDetail
